import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#212121', contrastText: '#FFFFFF' },
    secondary: { main: '#424242', contrastText: '#FFFFFF' },
    tertiary: { main: '#616161', contrastText: '#FFFFFF' },
    background: { default: '#FAFAFA', paper: '#FFFFFF' },
    text: { primary: '#212121', secondary: '#757575' },
  },
  typography: {
    fontFamily: "'Noto Sans JP', 'Roboto', sans-serif",
    button: { textTransform: 'none', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 16, textTransform: 'none', fontWeight: 500 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, border: '1px solid #E0E0E0' },
      },
    },
  },
  brand: {
    gradient: 'linear-gradient(135deg, #212121 0%, #424242 50%, #616161 100%)',
    platformGradient: 'linear-gradient(to right, #212121, #616161)',
    headerTextColor: '#FFFFFF',
  },
});
